import { useCallback } from 'react';

import { buildPayloadForInProductMarketing } from 'utils/common';

export function useC2BGenerateLeads({
    adType,
    companySize,
    isImpersonatingUser,
    loggedUser,
    optyName,
    pendoId = '',
    sendEmail,
    source,
}) {
    const generateC2BLeads = useCallback(async () => {
        let status = false;
        const EmployeeCount = companySize;

        try {
            const params = buildPayloadForInProductMarketing(
                loggedUser,
                isImpersonatingUser,
                optyName,
                pendoId,
                source,
                adType,
                EmployeeCount
            );
            await sendEmail({ params });
            status = true;
        } catch (e) {
            status = false;
        }

        return status;
    }, [
        adType,
        companySize,
        isImpersonatingUser,
        loggedUser,
        optyName,
        pendoId,
        sendEmail,
        source,
    ]);

    const generateC2BAdditionalProductsLeads = useCallback(
        async (optyNameAttr, pendoIdAttr, sourceAttr, adTypeAttr) => {
            let status = false;
            const EmployeeCount = companySize;

            try {
                const params = buildPayloadForInProductMarketing(
                    loggedUser,
                    isImpersonatingUser,
                    optyNameAttr,
                    pendoIdAttr,
                    sourceAttr,
                    adTypeAttr,
                    EmployeeCount
                );
                await sendEmail({ params });
                status = true;
            } catch (e) {
                status = false;
            }

            return status;
        },
        [companySize, isImpersonatingUser, loggedUser, sendEmail]
    );

    return { generateC2BLeads, generateC2BAdditionalProductsLeads };
}
